module.exports = __webpack_public_path__ + "img/四川天府新区祥鹤三街幼儿园.39df3991.jpg";